import { render, staticRenderFns } from "./BaseThermometerProgressBar.vue?vue&type=template&id=6065402d&scoped=true&"
import script from "./BaseThermometerProgressBar.vue?vue&type=script&lang=js&"
export * from "./BaseThermometerProgressBar.vue?vue&type=script&lang=js&"
import style0 from "./BaseThermometerProgressBar.vue?vue&type=style&index=0&id=6065402d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6065402d",
  null
  
)

export default component.exports